import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: '首页',
    component: () => import('@/views/MainPage.vue'),
    children:[
      {
        path:'product',
        name:'产品服务',
        component:()=>import('@/views/productService/index.vue'),
        children:[
          {
            path:'drawingsReview',
            name:'各专业图纸版本一致性审查',
            component:()=>import('@/views/productService/component/DrawingsReview.vue'),
          },
          {
            path:'dwgProblem',
            name:'图面问题审查',
            component:()=>import('@/views/productService/component/DWGProblems.vue'),
          },
          {
            path:'allRefineModel',
            name:'全专业精细化BIM模型',
            component:()=>import('@/views/productService/component/AllRefineModel.vue'),
          },
          {
            path:'modelAccuracyQuality',
            name:'模型精度（质量）审查',
            component:()=>import('@/views/productService/component/ModelAccuracyQuality.vue'),
          },
          {
            path:'drawingModel',
            name:'图模一致性审查',
            component:()=>import('@/views/productService/component/DrawingModel.vue'),
          },
          {
            path:'collisionDetection',
            name:'碰撞检测',
            component:()=>import('@/views/productService/component/CollisionDetection.vue'),
          },
          {
            path:'clearanceAnalysis',
            name:'净空分析',
            component:()=>import('@/views/productService/component/ClearanceAnalysis.vue'),
          },
          {
            path:'smartDrawing',
            name:'智绘图签',
            component:()=>import('@/views/productService/component/SmartDrawing.vue')
          },
          {
            path:'legendLibrary',
            name:'图例库',
            component:()=>import('@/views/productService/component/LegendLibrary.vue')
          },
           {
            path:'designControl',
            name:'设计管理平台',
            component:()=>import('@/views/productService/component/DesignControl.vue')
          },
          {
            path:'netHeightAnalysis',
            name:'净高分析',
            component:()=>import('@/views/productService/component/NetHeightAnalysis.vue')
          }
        ]
      },
      // {
      //   path:'achievement',
      //   name:'成果展示',
      //   component:()=>import('@/views/achievementShow/index.vue')
      // },
      {
        path:'aboutUs',
        name:'关于我们',
        component:()=>import('@/views/aboutUs/index.vue')
      },
      {
        path:'contactUs',
        name:'联系我们',
        component:()=>import('@/views/contactUs/index.vue')
      },
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
